/**
 *
 * Asynchronously loads the component for AdminProfilerCandidates
 *
 */

import Loadable from 'react-loadable';

export default Loadable({
  loader: () => import('./index'),
  loading: () => null,
});



// WEBPACK FOOTER //
// ./src/ui/graphql/AdminProfilerCandidates/loadable.js